(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('vv-product-form')) {
    customElements.define('vv-product-form', class extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('[data-variant]');
        if (!this.variantInput) return;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.changeVariant = () => {
          const variant = this.variants.find((item) => String(item.id) === this.variantInput.value);
          if (!variant) return;
          this.querySelector('[data-price]').textContent = variant.price;
          const addButton = this.querySelector('[data-add]');
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
          this.querySelector('[data-availability]').textContent = variant.available ? '' : 'Diese Variante ist derzeit nicht verfügbar.';
          const quantity = this.querySelector('[data-quantity]');
          quantity.min = variant.min;
          quantity.step = variant.increment;
          if (variant.max == null) quantity.removeAttribute('max');
          else quantity.max = variant.max;
          quantity.value = variant.min;
          const image = this.querySelector('.vv-product__image');
          if (image && variant.image) {
            image.src = variant.image;
            image.removeAttribute('srcset');
            image.alt = variant.imageAlt;
          }
          const nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', nextUrl);
        };
        this.variantInput.addEventListener('change', this.changeVariant);
      }
      disconnectedCallback() {
        this.variantInput?.removeEventListener('change', this.changeVariant);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
